var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vu-meter"},[_c('canvas',{directives:[{name:"draw-meter",rawName:"v-draw-meter",value:({ amp: _vm.dBVal, peak: _vm.dBPeakVal, clipSize: _vm.clipSize }),expression:"{ amp: dBVal, peak: dBPeakVal, clipSize }"}],attrs:{"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }